<template>
  <div class="homepage-topics">
    <h2 class="comm-title">精选专题</h2>
    <h3 class="comm-subtitle">我们是航海家，更是梦想家</h3>
    <Swiper
      ref="bannerSwiper"
      :options="swiperOptions"
      class="swiper-container swiper-topics topics"
    >
      <SwiperSlide
        v-for="(item, i) in promoBanners"
        :key="i"
        class="swiper-slide promoBannerLink external"
      >
        <a :href="item.linkUrl" @click="onTopicClicked(i, item.linkUrl)">
          <img :src="item.mobileImage" />
        </a>
      </SwiperSlide>
      <div
        ref="swiper-pagination"
        class="swiper-pagination"
        v-if="promoBanners.length > 1"
        slot="pagination"
      ></div>
    </Swiper>
  </div>
</template>


<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { gioAdsTracking } from "@/utilities/tools";
export default {
  name: "HomeTopic",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: {
    promoBanners: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        loop: true,
        autoplay: {
          delay: 5000,
        },
      },
    };
  },
  methods: {
    getGioTitle(i) {
      let growingIOTitle = "";
      if (i == 0) {
        growingIOTitle = "左2";
      } else if (i == 1) {
        growingIOTitle = "中2";
      } else if (i == 2) {
        growingIOTitle = "右2";
      }
      return growingIOTitle;
    },
		onTopicClicked (index, url) {
			const eventObject = {
				"adsType": "ch",
				"chOrder": index+1,
				"desUrl": url
			}
			gioAdsTracking(eventObject);
		}
  },
  computed: {},
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  
  text-transform: uppercase;
}
img {
  display: block;
}

/*精选专题*/
.comm-title {
  width: 100%;
  text-align: center;
  font-size: 23px;
  font-weight: bold;
  color: #282b2c;
  line-height: 33px;
}
.comm-subtitle {
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  color: #282b2c;
  line-height: 22px;
  text-align: center;
  margin-bottom: 15px;
}
.homepage-topics {
  margin-bottom: 45px;
}
.homepage-topics .swiper-container {
  width: 375px;
  height: 218px;
}
.homepage-topics .swiper-container .swiper-pagination-bullets {
  bottom: -4px;
}

.homepage-topics .swiper-container .swiper-pagination {
  /*margin-bottom: -34px;*/
}
.homepage-topics .swiper-container img {
  width: 100%;
  height: 200px;
}
</style>

<style lang="less">
.homepage-topics
  .swiper-container
  .swiper-pagination
  .swiper-pagination-bullet-active {
  transform: scale(1.5);
  background: #fbc500;
}
</style>
